import { ALL_SELECT_VALUE, ALL_SELECT_VALUE_STRING } from '../../utils/constants/global-constants'

export interface optionsTypes {
  readonly color?: string
  readonly isDisabled?: boolean
  readonly isFixed?: boolean
  readonly label?: string
  readonly rating?: string
  readonly type?: string
  readonly value?: boolean | number | string
}
export interface Dropdown {
  label: string
  value: null | number | string
}
export const year: optionsTypes[] = [
  { label: 'All', value: ALL_SELECT_VALUE },
  { label: '2023', value: 2023 },
  { label: '2024', value: 2024 },
]
export const userrolesdrodown: readonly optionsTypes[] = [
  { label: 'MPF Owners', value: 'MPF Owner' },
  { label: 'MPF Leadership', value: 'Leadership' },
  { label: 'Career Development', value: 'CD' },
  { label: 'Customer Support', value: 'CS' },
  { label: 'Force Management', value: 'FM' },
  {
    label: 'Installation Personnel Readines',
    value: 'IPR',
  },
  {
    label: 'Personnel Systems Management',
    value: 'PSM',
  },
  { label: 'CSS', value: 'CSS' },
]

export const IsArchived: optionsTypes[] = [
  { label: 'Yes', value: true },
  { label: 'No', value: false },
]

export const ViewInquiries: optionsTypes[] = [
  { label: 'All', value: ALL_SELECT_VALUE_STRING },
  { label: 'Self', value: 'Self' },
  { label: 'Other', value: 'Other' },
]

export const CurrentServicingUnit: optionsTypes[] = [
  { label: 'All', value: ALL_SELECT_VALUE_STRING },
  { label: 'MPF', value: 'MPF' },
  { label: 'CSS', value: 'CSS' },
]

export const Section: readonly optionsTypes[] = [
  { label: 'All', value: 'All' },
  { label: 'Career Development', value: 'Career Development' },
  { label: 'Customer Support', value: 'Customer Support' },
  { label: 'Force Management', value: 'Force Management' },
  {
    label: 'Installation Personnel Readiness',
    value: 'Installation Personnel Readiness',
  },
  {
    label: 'Personnel Systems Management',
    value: 'Personnel Systems Management',
  },
]

export const ContentCategory: readonly optionsTypes[] = [{ label: 'Category', value: 'Category' }]

export const ContentSection: readonly optionsTypes[] = [
  { label: 'All', value: 'All' },
  { label: 'Section', value: 'Section' },
  { label: 'Career Development', value: 'Career Development' },
  { label: 'Customer Support', value: 'Customer Support' },
  { label: 'Force Management', value: 'Force Management' },
  {
    label: 'Installation Personnel Readiness',
    value: 'Installation Personnel Readiness',
  },
  {
    label: 'Personnel Systems Management',
    value: 'Personnel Systems Management',
  },
]

export const DashboardCategory: readonly optionsTypes[] = [
  { label: 'All', value: 'All' },
  { label: 'Adverse Action', value: 'Adverse Action' },
  {
    label: 'Air Force Personnel Accountability and Assessment System (AFPAAS)',
    value: 'Air Force Personnel Accountability and Assessment System (AFPAAS)',
  },
  { label: 'Awards &amp; Decorations', value: 'Awards &amp; Decorations' },
  { label: 'Citizenship', value: 'Citizenship' },
  { label: 'DEERS Update', value: 'DEERS Update' },
  { label: 'Deployment', value: 'Deployment' },
  { label: 'Duty Information Update', value: 'Duty Information Update' },
  { label: 'Evaluation', value: 'Evaluation' },
  { label: 'Exercises', value: 'Exercises' },
  {
    label: 'Initial Enlistment Bonus (IEB)',
    value: 'Initial Enlistment Bonus (IEB)',
  },
  { label: 'Personnel System Access', value: 'Personnel System Access' },
  { label: 'Personnel System Removal', value: 'Personnel System Removal' },
  { label: 'Promotions', value: 'Promotions' },
  { label: 'RIP Request', value: 'RIP Request' },
  { label: 'Retentions', value: 'Retentions' },
  { label: 'Retirements', value: 'Retirements' },
  { label: 'Roster Request', value: 'Roster Request' },
  { label: 'Separations', value: 'Separations' },
  { label: 'TEST0001a', value: 'TEST0001a' },
  { label: 'testtt', value: 'testtt' },
]
export const homecategory: readonly optionsTypes[] = [
  { label: 'Category', value: 'Category' },
  { label: 'Adverse Action', value: 'Adverse Action' },
  {
    label: 'Air Force Personnel Accountability and Assessment System (AFPAAS)',
    value: 'Air Force Personnel Accountability and Assessment System (AFPAAS)',
  },
  { label: 'Awards &amp; Decorations', value: 'Awards &amp; Decorations' },
  { label: 'Citizenship', value: 'Citizenship' },
  { label: 'DEERS Update', value: 'DEERS Update' },
  { label: 'Deployment', value: 'Deployment' },
  { label: 'Duty Information Update', value: 'Duty Information Update' },
  { label: 'Evaluation', value: 'Evaluation' },
  { label: 'Exercises', value: 'Exercises' },
  {
    label: 'Initial Enlistment Bonus (IEB)',
    value: 'Initial Enlistment Bonus (IEB)',
  },
  { label: 'Personnel System Access', value: 'Personnel System Access' },
  { label: 'Personnel System Removal', value: 'Personnel System Removal' },
  { label: 'Promotions', value: 'Promotions' },
  { label: 'RIP Request', value: 'RIP Request' },
  { label: 'Retentions', value: 'Retentions' },
  { label: 'Retirements', value: 'Retirements' },
  { label: 'Roster Request', value: 'Roster Request' },
  { label: 'Separations', value: 'Separations' },
  { label: 'TEST0001a', value: 'TEST0001a' },
  { label: 'testtt', value: 'testtt' },
]
export const SubCategory: readonly optionsTypes[] = [
  { label: 'All', value: 'All' },
  { label: '(Empty)', value: 'Empty' },
  { label: 'Administrative Discharge', value: 'Administrative Discharge' },
  {
    label: 'Air and Space Expeditionary Force Indicator (AEFI)',
    value: 'Air and Space Expeditionary Force Indicator (AEFI)',
  },
  { label: 'BLSDM', value: 'BLSDM' },
  { label: 'Bonus Pay', value: 'Bonus Pay' },
  { label: 'CMS', value: 'CMS' },
  {
    label: 'CONUS/Stateside - Out-processing',
    value: 'CONUS/Stateside - Out-processing',
  },
  {
    label: 'CONUS/Stateside - PCS Orders',
    value: 'CONUS/Stateside - PCS Orders',
  },
  {
    label: 'CONUS/Stateside - Projected Departure Date Change',
    value: 'CONUS/Stateside - Projected Departure Date Change',
  },
  { label: 'Cancel Decoration', value: 'Cancel Decoration' },
  {
    label: 'Commander Representative Appointment',
    value: 'Commander Representative Appointment',
  },
  {
    label: 'Contingency, Exercise, Deployment (CED) orders',
    value: 'Contingency, Exercise, Deployment (CED) orders',
  },
  { label: 'Correction of Evaluation', value: 'Correction of Evaluation' },
  { label: 'Enlisted', value: 'Enlisted' },
  { label: 'Enlisted Promotion', value: 'Enlisted Promotion' },
  { label: 'Extension', value: 'Extension' },
  { label: 'G-Series', value: 'G-Series' },
  { label: 'Medical Separation', value: 'Medical Separation' },
  { label: 'Missing Decoration', value: 'Missing Decoration' },
  { label: 'No Pay', value: 'No Pay' },
  { label: 'Officer', value: 'Officer' },
  { label: 'Officer Promotion', value: 'Officer Promotion' },
  { label: 'PRDA', value: 'PRDA' },
  { label: 'Reenlistment', value: 'Reenlistment' },
  { label: 'Reports', value: 'Reports' },
  { label: 'Request Decoration', value: 'Request Decoration' },
  { label: 'Travel', value: 'Travel' },
]
export const AssignedUsers: optionsTypes = { label: 'Select user', value: '' }

export const AssignedLocation: readonly optionsTypes[] = [
  { label: 'All', value: '' },
  { label: 'EGLIN AFB FL', value: 'EGLIN AFB FL' },
]

export const Organization: readonly optionsTypes[] = [
  { label: 'All', value: 'All' },
  { label: '15 TEST FT', value: '15 TEST FT' },
  { label: '325 COMMUNICATIONS SQ A', value: '325 COMMUNICATIONS SQ A' },
  { label: '33 FIGHTER WG', value: '33 FIGHTER WG' },
  { label: '350 SPECTRUM WARFARE GP', value: '350 SPECTRUM WARFARE GP' },
  { label: '359 TRAINING SQ', value: '359 TRAINING SQ' },
  { label: '366 TRAINING SQ 3', value: '366 TRAINING SQ 3' },
  { label: '39 ELECTRONIC WARFARE SQ', value: '39 ELECTRONIC WARFARE SQ' },
  { label: '492 SPECIAL OPERATIONS GP', value: '1492 SPECIAL OPERATIONS GP' },
  { label: '513 ELECTRONIC WARFARE SQ', value: '513 ELECTRONIC WARFARE SQ' },
  { label: '53 COMPUTER SYSTEMS SQ', value: '53 COMPUTER SYSTEMS SQ' },
  { label: '850 SPECTRUM WARFARE GP', value: '850 SPECTRUM WARFARE GP' },
  { label: '86 FIGHTER WEAPONS SQ 1', value: '86 FIGHTER WEAPONS SQ 1' },
  { label: '96 COMMUNICATIONS SQ', value: '96 COMMUNICATIONS SQ' },
  { label: '96 CYBERSPACE TEST GP', value: '96 CYBERSPACE TEST GP' },
  { label: '96 FORCE SUPPORT SQ', value: '96 FORCE SUPPORT SQ' },
  { label: '96 INPATIENT OPS SQ', value: '96 INPATIENT OPS SQ' },
  { label: '96 MEDICAL GP', value: '96 MEDICAL GP' },
  { label: '96 SECURITY FORCES SQ', value: '96 SECURITY FORCES SQ' },
  { label: 'AF AUDIT AGENCY FO 2', value: 'AF AUDIT AGENCY FO 2' },
  { label: 'AF AUDIT AGENCY FO 2SPT', value: 'AF AUDIT AGENCY FO 2SPT' },
  { label: 'AF CIV CAREER TNG FO BR', value: 'AF CIV CAREER TNG FO BR' },
  { label: 'AF INST OF TECH IN AFST', value: 'AF INST OF TECH IN AFST' },
  { label: 'AF LEGAL OP AGENCY FO', value: 'AF LEGAL OP AGENCY FO' },
  { label: 'AF OP TST EVAL CTR DU 2', value: 'AF OP TST EVAL CTR DU 2' },
  { label: 'AF PERSONNEL CTR FO IED', value: 'AF PERSONNEL CTR FO IED' },
  { label: 'AF-SPEC-OPNS CM K', value: 'AF-SPEC-OPNS CM K' },
  { label: 'AFROTC SOUTHEAST RG 14A', value: 'AFROTC SOUTHEAST RG 14A' },
  { label: 'AIR WAR COLLEGE CL', value: 'AIR WAR COLLEGE CL' },
  { label: 'TEST NEW ORG', value: 'TEST NEW ORG' },
  { label: 'TEST ORGATP', value: 'TEST ORGATP' },
  { label: 'Test Org MPF', value: 'Test Org MPF' },
  { label: 'test', value: 'test' },
]

export const Priority: optionsTypes[] = [
  { label: 'Select', value: '' },
  { label: 'High', value: 'High' },
  { label: 'Normal', value: 'Normal' },
]

export const Submitted: optionsTypes[] = [
  { label: 'All', value: '' },
  { label: 'Last 24 hours', value: 'Last 24 hours' },
  { label: 'Last 48 hours', value: 'Last 48 hours' },
  { label: 'Last 3 days', value: 'Last 3 days' },
  { label: 'Last 7 days', value: 'Last 7 days' },
  { label: 'Last 15 days', value: 'Last 15 days' },
  { label: 'Last 30 days', value: 'Last 30 days' },
  { label: 'More than 30 days', value: 'More than 30 days' },
]
export const ResolvedClosed: optionsTypes[] = [
  { label: 'All', value: '' },
  { label: 'Last 24 hours', value: 'Last 24 hours' },
  { label: 'Last 48 hours', value: 'Last 48 hours' },
  { label: 'Last 3 days', value: 'Last 3 days' },
  { label: 'Last 7 days', value: 'Last 7 days' },
  { label: 'Last 15 days', value: 'Last 15 days' },
  { label: 'Last 30 days', value: 'Last 30 days' },
  { label: 'More than 30 days', value: 'More than 30 days' },
]
export const Closed: optionsTypes[] = [
  { label: 'All', value: '' },
  { label: 'Last 24 hours', value: 'Last 24 hours' },
  { label: 'Last 48 hours', value: 'Last 48 hours' },
  { label: 'Last 3 days', value: 'Last 3 days' },
  { label: 'Last 7 days', value: 'Last 7 days' },
  { label: 'Last 15 days', value: 'Last 15 days' },
  { label: 'Last 30 days', value: 'Last 30 days' },
  { label: 'More than 30 days', value: 'More than 30 days' },
]
export const FilterBy: readonly optionsTypes[] = [
  { label: 'All', value: 'All' },
  { label: 'Read', value: 'Read' },
  { label: 'Unread', value: 'Unread' },
]

export const Dates: readonly optionsTypes[] = [
  { label: 'All', value: 'All' },
  { label: 'Last 3', value: 'Last 3 days' },
  { label: 'Last 5', value: 'Last 5 days' },
  { label: 'Last 7', value: 'Last 7 days' },
  { label: 'Last 10', value: 'Last 10 days' },
  { label: 'Last 15', value: 'Last 15 days' },
  { label: 'More than 15', value: 'More than 15 days' },
]

export const Status: optionsTypes[] = [
  { label: 'Select', value: '' },
  { label: 'Published', value: 'Published' },
  { label: 'Saved', value: 'Saved' },
]

export const CSS: optionsTypes[] = [
  { label: 'No', value: 'No' },
  { label: 'Yes', value: 'Yes' },
]

export const AssignedComponent: readonly optionsTypes[] = [
  { label: 'Regular Air Force', value: 143 },
  { label: 'Air Force Reserve Command', value: 144 },
  { label: 'Air National Guard', value: 145 },
]

export const ComponentsShortNameValue = {
  AFRC: 'Air Force Reserve Command',
  ANG: 'Air National Guard',
  RegAF: 'Regular Air Force',
}
export const SettingsAssignedComponent: readonly optionsTypes[] = [
  { label: 'Select', value: -1 },
  { label: 'Regular Air Force', value: 143 },
  { label: 'Air Force Reserve Command', value: 144 },
  { label: 'Air National Guard', value: 145 },
]
export const SettingsServicingMAJCOM: readonly optionsTypes[] = [
  { label: 'Select Servicing MAJCOM', value: 'Select Servicing MAJCOM' },
  { label: 'AFSOC', value: 'AFSOC' },
  { label: 'USAFE', value: 'USAFE' },
  { label: 'AFDW', value: 'AFDW' },
  { label: 'AETC', value: 'AETC' },
  { label: 'PACAF', value: 'PACAF' },
  { label: 'AMC', value: 'AMC' },
  { label: 'AFGSC', value: 'AFGSC' },
  { label: 'ACC', value: 'ACC' },
  { label: 'AFSPC', value: 'AFSPC' },
  { label: 'AFMC', value: 'AFMC' },
  { label: 'USAFA', value: 'USAFA' },
]

export const ServicingMAJCOM: readonly optionsTypes[] = [
  { label: 'All', value: 'All' },
  { label: 'AFSOC', value: 'AFSOC' },
  { label: 'USAFE', value: 'USAFE' },
  { label: 'AFDW', value: 'AFDW' },
  { label: 'AETC', value: 'AETC' },
  { label: 'PACAF', value: 'PACAF' },
  { label: 'AMC', value: 'AMC' },
  { label: 'AFGSC', value: 'AFGSC' },
  { label: 'ACC', value: 'ACC' },
  { label: 'AFSPC', value: 'AFSPC' },
  { label: 'AFMC', value: 'AFMC' },
  { label: 'USAFA', value: 'USAFA' },
]

export const ServicedBy: readonly optionsTypes[] = [
  { label: 'All', value: '' },
  { label: 'MPF', value: 'MPF' },
  { label: 'CSS', value: 'CSS' },
]

export const ProfileStatus: readonly optionsTypes[] = [
  { label: 'Select', value: 'Select' },
  { label: 'Active Duty', value: 'Active Duty' },
  { label: 'Civilian', value: 'Civilian' },
  { label: 'Contractor', value: 'Contractor' },
]

export const ProfileRank: readonly optionsTypes[] = [
  { label: 'Select', value: 'Select' },
  { label: 'AB', value: 'AB' },
  { label: 'Amn', value: 'Amn' },
  { label: 'A1C', value: 'A1C' },
  { label: 'SrA', value: 'SrA' },
  { label: 'SSgt', value: 'SSgt' },
  { label: 'TSgt', value: 'TSgt' },
  { label: 'MSgt', value: 'MSgt' },
  { label: 'SMSgt', value: 'SMSgt' },
  { label: 'CMSgt', value: 'CMSgt' },
  { label: '2d Lt', value: '2d Lt' },
  { label: '1st Lt', value: '1st Lt' },
  { label: 'Capt', value: 'Capt' },
  { label: 'Maj', value: 'Maj' },
  { label: 'Lt Col', value: 'Lt Col' },
  { label: 'Col', value: 'Col' },
  { label: 'Brig Gen', value: 'Brig Gen' },
  { label: 'Maj Gen', value: 'Maj Gen' },
  { label: 'Lt Gen', value: 'Lt Gen' },
  { label: 'Gen', value: 'Gen' },
  { label: 'Spc1', value: 'Spc1' },
  { label: 'Spc2', value: 'Spc2' },
  { label: 'Spc3', value: 'Spc3' },
  { label: 'Spc4', value: 'Spc4' },
  { label: 'Sgt', value: 'Sgt' },
]

export const CellPhoneProvider: optionsTypes[] = [
  { label: 'Select', value: 'Select' },
  { label: 'AT&T', value: 'AT&T' },
  { label: 'T-Mobile', value: 'T-Mobile' },
  { label: 'Other', value: 'Other' },
]

export const PRP: readonly optionsTypes[] = [
  { label: 'Yes', value: 'Yes' },
  { label: 'No', value: 'No' },
]

export const AssignTodropdown: readonly optionsTypes[] = [
  { label: 'Select', value: 'Select' },
  {
    label: 'Customer Support Technician',
    value: 'Customer Support Technician',
  },
  {
    label: 'Customer Support Supervisor',
    value: 'Customer Support Supervisor',
  },
  {
    label: 'Customer Support Section Chief',
    value: 'Customer Support Section Chief',
  },
  { label: 'MPF Leadership', value: 'MPF Leadership' },
]

export const SelectUserdropdown: readonly optionsTypes[] = [
  { label: 'Select', value: 'Select' },
  { label: 'Test JH3', value: 'Test JH3' },
  { label: 'Test JH4', value: 'Test JH4' },
  { label: 'Test CO3', value: 'Test CO3' },
  { label: 'Test CO4', value: 'Test CO4' },
]
export const OtherSection: readonly optionsTypes[] = [
  { label: 'Select', value: 'Select' },
  { label: 'Career Development', value: 'Career Development' },
  { label: 'Customer Support', value: 'Customer Support' },
  { label: 'Force Management', value: 'Force Management' },
  {
    label: 'Installation Personnel Readiness',
    value: 'Installation Personnel Readiness',
  },
  {
    label: 'Personnel Systems Management',
    value: 'Personnel Systems Management',
  },
]
export const ElevateTodropdown: readonly optionsTypes[] = [
  { label: 'Select', value: 'Select' },
  {
    label: 'Customer Support Supervisor',
    value: 'Customer Support Supervisor',
  },
  {
    label: 'Customer Support Section Chief',
    value: 'Customer Support Section Chief',
  },
]
export const homeSection: readonly optionsTypes[] = [
  { label: 'All', value: 'All' },
  { label: 'Section', value: 'Section' },
  { label: 'Career Development', value: 'Career Development' },
  { label: 'Customer Support', value: 'Customer Support' },
  { label: 'Force Management', value: 'Force Management' },
  {
    label: 'Installation Personnel Readiness',
    value: 'Installation Personnel Readiness',
  },
  {
    label: 'Personnel Systems Management',
    value: 'Personnel Systems Management',
  },
]
export const RNLTD: optionsTypes[] = [
  { label: 'All', value: '' },
  { label: 'Next 1 days', value: 'Next 1 days' },
  { label: 'Next 2 days', value: 'Next 2 days' },
  { label: 'Next 5 days', value: 'Next 5 days' },
  { label: 'Next 6 days', value: 'Next 6 days' },
]
export const PDD: optionsTypes[] = [
  { label: 'All', value: '' },
  { label: 'Next 1 days', value: 'Next 1 days' },
  { label: 'Next 2 days', value: 'Next 2 days' },
  { label: 'Next 5 days', value: 'Next 5 days' },
  { label: 'Next 6 days', value: 'Next 6 days' },
]
export const DOS: optionsTypes[] = [
  { label: 'All', value: '' },
  { label: 'Next 1 days', value: 'Next 1 days' },
  { label: 'Next 2 days', value: 'Next 2 days' },
  { label: 'Next 5 days', value: 'Next 5 days' },
  { label: 'Next 6 days', value: 'Next 6 days' },
]
export const DueOutPRP: optionsTypes[] = [
  { label: 'All', value: '' },
  { label: 'Yes', value: 'Yes' },
  { label: 'No', value: 'No' },
]
export const DueOutPriority: optionsTypes[] = [
  { label: 'All', value: '' },
  { label: 'High', value: 'High' },
  { label: 'Normal', value: 'Normal' },
]
export const DueDate: optionsTypes[] = [
  { label: 'All', value: '' },
  { label: 'Next 1 days', value: 'Next 1 days' },
  { label: 'Next 2 days', value: 'Next 2 days' },
  { label: 'Next 5 days', value: 'Next 5 days' },
  { label: 'Next 6 days', value: 'Next 6 days' },
]
